import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    div {
      margin-top: 30px;
    }

    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
      color: #000;
    }
    .check {
      margin: 8px 0;
      color: #000;
      position: relative;
      padding: 0 22px;
      text-align: left;
    }
    input[type="checkbox"] + label {
      position: absolute;
      top: -2px;
      left: 0;
    }
    .check_all {
      border-top: 1px solid #ddd;
    }
    .check_all p {
      color: #002c5f;
      font-weight: bold;
      font-size: 13px;
    }
  }
`;

const AgreementDiv = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};

export default AgreementDiv;
